import React from 'react';
import Grid from '../components/Core/Grid';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function KitLogGridViewer(props: any) {
    const kitId = props.data?.id;

    const initialFilter = kitId
        ? [{ name: 'kit_id', value: String(kitId), operator: 'eq' }]
        : [];

    return (
        <>
            <WindowBody noPadding>
                <Grid
                    router="kitlog"
                    initialFilter={initialFilter}
                    selectionMode="none"
                    hideDefaultActions
                />
            </WindowBody>
            <WindowFooter>
                <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
            </WindowFooter>
        </>
    );
}
